import commonConstant from '../../common/_commonConstant';

export const setBuildingParkingFeeModelCar = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_FEE_MODEL_CAR_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_FEE_MODEL_CAR_SUCCESS,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingParkingFeeModelMotorcycle = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_FEE_MODEL_MOTORCYCLE_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingInformation = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_INFORMATION_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_INFORMATION_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setRedemptionModelInformation = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_REDEMPTION_MODEL_INFORMATION_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_REDEMPTION_MODEL_INFORMATION_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setConfigCommon = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_CONFIG_COMMON_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_CONFIG_COMMON_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);


export const setConfig = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_CONFIG_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_CONFIG_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingContent = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_CONTENT_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_CONTENT_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingTenant = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_TENANT_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_TENANT_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingIotDevice = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_BUILDING_IOT_DEVICE_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_BUILDING_IOT_DEVICE_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setBuildingParkingDayConfig = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_DAY_CONFIG_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_BUILDING_PARKING_DAY_CONFIG_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setCurrentBuildingDataPath = data => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SET_CURRENT_BUILDING_DATA_PATH_SUCCESS,
        'data': data,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SET_CURRENT_BUILDING_DATA_PATH_FAILURE,
        'data': data,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
